/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditsrefillshort2Inputs */

const en_creditsrefillshort2 = /** @type {(inputs: Creditsrefillshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tops up on the 1st of every month.`)
};

const de_creditsrefillshort2 = /** @type {(inputs: Creditsrefillshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füllt sich am 1. jedes Monats auf.`)
};

/**
* | output |
* | --- |
* | "Tops up on the 1st of every month." |
*
* @param {Creditsrefillshort2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditsrefillshort2 = /** @type {((inputs?: Creditsrefillshort2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditsrefillshort2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditsrefillshort2(inputs)
	return de_creditsrefillshort2(inputs)
});
export { creditsrefillshort2 as "creditsRefillShort" }